import { StringToNumberMap } from '../../types/common';
import { PlayerRole } from '../../types/player';


export const playerRoleToSortOrder: Record<PlayerRole, number> = {

  // team roles
  'keyPlayer': 30,
  'valuePlayer': 24,
  'rotationPlayer': 20,
  'loanedIn': 18,
  'developmentPlayer': 16,
  'reserve': 14,
  'longTermInjured': 12,
  'loanedOut': 10,

  // academy roles
  'trialist': 6,
  'performancePlayer': 5,
  'highPotentialPlayer': 4,
  'outplacementPlayer': 3,
  'transferTarget': 2,
};


export const playerRoleToIndexEquivalent: StringToNumberMap = {
  'keyPlayer': 10,
  'valuePlayer': 60 / 7,
  'rotationPlayer': 50 / 7,
  'loanedIn': 40 / 7,
  'developmentPlayer': 30 / 7,
  'reserve': 20 / 7,
  'longTermInjured': 10 / 7,
  'loanedOut': 0,
};


export const teamRoles: PlayerRole[] = [
  'keyPlayer',
  'valuePlayer',
  'rotationPlayer',
  'loanedIn',
  'developmentPlayer',
  'reserve',
  'longTermInjured',
  'loanedOut',
];


export const academyRoles: PlayerRole[] = [
  'trialist',
  'highPotentialPlayer',
  'performancePlayer',
  'outplacementPlayer',
  'transferTarget',
];
